import AuthLoginForm from "../components/AuthLoginForm";
import { SEOHead } from "@/components/SEOHead";
import { Store } from "lucide-react";

const Login = () => (
  <>
    <SEOHead
      title="Sign In - Bahama Marketplace"
      description="Sign in to your Bahama Marketplace account and start shopping from amazing local sellers across the Bahamas."
      keywords="login, sign in, Bahama Marketplace account, authentication"
    />
    <main className="flex min-h-screen items-center justify-center bg-background py-12 px-4">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border/40 rounded-lg shadow-luxury-lg p-8">
          <div>
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Store className="h-8 w-8 text-primary" />
            </div>
            <h1 className="text-3xl font-bold text-center mb-2">Welcome back</h1>
            <p className="text-muted-foreground text-center mb-8">
              Sign in to continue shopping on Bahama Marketplace
            </p>
          </div>
          <AuthLoginForm />
        </div>
      </div>
    </main>
  </>
);

export default Login;